<template>
  <div>
    <!--<page-heading-info
    title="Jefferson County Auditor's Office"
    phone="(740) 283-8511"
    courthouse="true"
    hours="8:30 - 4:30 (M-F)"
    floor="4th Floor"
    ></page-heading-info>-->
    <page-heading-info
      title="Auditor's Archived Documents"
    />

    <!-- auditor document downloads -->
    <text-box-title class="mt-3" title="Jefferson County Auditor Downloads">
      <note-documents note-id="64" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

    <text-box-title title="Jefferson County Special Assessments">
      <note-documents note-id="24" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

    <text-box-title title="Jefferson County 5 Year Budget Reports">
      <note-documents note-id="3" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

    <text-box-title title="Jefferson County Annual Financial Reports">
      <note-documents note-id="4" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import LinkBox from '@/components/layout/LinkBox.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'

export default {
  components: {
    PageHeadingInfo,
    TextBoxTitle,
    LinkBox,
    NoteDocuments
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
	.complaint-box a {
		font-weight: normal;
		text-decoration: none;
		color: #37434d;
	}

	.complaint-box a:hover {
		text-decoration: underline;
	}

</style>
